<script>
import tippy from "tippy.js";
import { ref, onMounted } from "@vue/runtime-core";
  
export default {
  name: "ToolTip",

  props: {
    text: {
      type: String,
      required: true,
    },

    options: {
      type: Object,
      default: null,
    },
  },

  setup(props) {
    const tooltipRef = ref(null);
    
    onMounted(() => {
      tippy(tooltipRef.value, {
        ...{
          content: props.text,
          interactive: props.text.indexOf("<") > -1 ? true : false,
          allowHTML: props.text.indexOf("<") > -1 ? true : false,
          placement: 'top',
          offset: [0, 25],
          role: 'tooltip',
        },
				...props.options
      });
    });

    return {
      tooltipRef,
    };
  }
}
</script>

<style lang="css" scoped>
  .toolTip {
    display: inline-block;
    margin-left: 12px;
  }
</style>

<template>
	<span 
    ref="tooltipRef" 
    class="toolTip" 
    role="button" 
    aria-label="Tooltip" 
    tabindex="0"
  >
    <slot></slot>
  </span>
</template>